"use strict";

/* eslint-disable */
/* this file was taken directly from the CMS */
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const cash_dom_1 = __importDefault(require("cash-dom"));
const lodash_1 = require("lodash");
const query_string_1 = __importDefault(require("query-string"));
const chartModifiers_1 = require("./chartModifiers");
function loadScript(url, callback) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  if (script.readyState) {
    // IE
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    // Others
    script.onload = function () {
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}
function default_1() {
  const queryState = query_string_1.default.parse(location.search).state ? query_string_1.default.parse(location.search).state : [];
  const states = Array.isArray(queryState) ? queryState : [queryState];
  for (const item of states) {
    const key = (0, lodash_1.findKey)(chartModifiers_1.stateToFips, st => st === item);
    (0, cash_dom_1.default)(`[data-state='${key}']`).addClass('active');
  }
  (0, cash_dom_1.default)('#finance-table-container').attr('data-states', JSON.stringify(states));
  (0, cash_dom_1.default)('#finance-table-container').attr('data-geo', !!states.length);
  const src = (0, cash_dom_1.default)('#finance-table-container').attr('data-src');
  loadScript(src, () => {});
  const links = (0, cash_dom_1.default)('.finance-table .anchormenu__link');
  links.removeClass('is-active');
  (0, cash_dom_1.default)(links[0]).addClass('is-active');
  links.on('click', function () {
    links.removeClass('is-active');
    (0, cash_dom_1.default)(this).addClass('is-active');
  });
}
exports.default = default_1;